import React, { createContext, useContext, useState } from 'react';

const ScoreBoldWordsContext = createContext();

export const WordsProvider = ({ children }) => {
  const [wordsInBold, setWordsInBold] = useState([]);

  const updateWordsInBold = (words) => {
    console.log('Updating words to highlight:', words);
    setWordsInBold(words || []);
  };

  const clearWordsInBold = () => {
    setWordsInBold([]);
  };

  return (
    <ScoreBoldWordsContext.Provider
      value={{
        wordsInBold,
        updateWordsInBold,
        clearWordsInBold,
      }}
    >
      {children}
    </ScoreBoldWordsContext.Provider>
  );
};

export const useWordsInBold = () => {
  const context = useContext(ScoreBoldWordsContext);
  if (!context) {
    throw new Error('useWords must be used within a WordsProvider');
  }
  return context;
};
